import { create } from "zustand";

type NavigationState = {
    currentPath: string | null;
    previousPath: string | null;
    isReady: boolean;
    setPath: (path: string) => void;
};
export const useNavigationStore = create<NavigationState>((set) => ({
    currentPath: null,
    previousPath: null,
    isReady: false,
    setPath: (path) =>
        set((state) => ({
            previousPath: state.currentPath,
            currentPath: path,
            isReady: true,
        })),
}));
